import { ConfirmationModal } from "views/components/common/ConfirmationModal";
import { LoginModal } from "views/mobile/screens/LoginModal";
import { RutModal as Modal } from "views/mobile/components/Popup/RutPopup2";
import { SignUpModal } from "views/mobile/screens/SignUpModal";

import { TicketWihtoutLogin } from "views/mobile/components/Popup/TicketWihtoutLogin";
import { getQuota } from "lib/timeblocks";

import Provider from "views/components/LineDetail";
import React from "reactn";
import { TicketDetailView } from "views/desktop/screens/TicketDetailView";

// Todo: too many props, separate in 2 or more components
const LineDetail = ({
	attention_type,
	webOnly,
	navigateToTicketScreen,
	user,
	setShowModalTemporary,
	showModalTemporary,
	isVisibleConfirmationModal,
	closeTicketWihtoutLogin,
	isVisibleModalWithoutLogin,
	showInputRutInModalWihtoutLogin,
	closeSignUpModal,
	signUpModalIsVisible,
	setIsVisibleConfirmationModal,
	isActiveRegistryModal,
	handlerWithoutLoginModal,
	isActiveLoginModal,
	closeLoginModal,
	loginModalIsVisible,
	ticketDisabled,
	reservationDisabled,
	ticketLabel,
	ticketAction,
	pickTicket,
	askForPhone,
	askForSsn,
	modalVisible,
	closeModal,
	currentTicket,
	todayTimeblocks,
	office,
	line,
	newTicket,
	navigateToReservationScreen,
	v2,
	setModalState,
	enabledReservations,
	restrictions,
	isDniRequired,
	isRutRequired,
	ticketFormsData,
}) => {
	return (
		<>
			<Modal
				visible={modalVisible}
				askForPhone={askForPhone}
				askForSsn={
					askForSsn ||
					(line && line.slug == "zero-q-demo-prueba-rut-no-borrar")
				}
				onClose={closeModal}
				pickTicket={pickTicket}
				isOngoing={newTicket.isOngoing}
				setModalState={setModalState}
			></Modal>
			<TicketDetailView
				restrictions={restrictions}
				attention_type={attention_type}
				navigateToTicketScreen={navigateToTicketScreen}
				user={user}
				office={office}
				line={line}
				ticket={currentTicket}
				quota={getQuota(todayTimeblocks)}
				ticketDisabled={ticketDisabled}
				ticketLabel={
					ticketDisabled ? "Fila deshabilitada" : ticketLabel
				}
				reservationDisabled={reservationDisabled}
				loading={newTicket.isOngoing}
				onTicketClick={ticketAction}
				onReservationClick={navigateToReservationScreen}
				v2={v2}
				webOnly={webOnly}
				enabledReservations={enabledReservations}
			/>
			{isVisibleConfirmationModal === true && (
				<ConfirmationModal label="¡Registro exitoso!" />
			)}
			<LoginModal
				openWithoutLoginModal={handlerWithoutLoginModal}
				isActiveLoginModal={isActiveLoginModal}
				onClose={closeLoginModal}
				visible={loginModalIsVisible}
				ticketAction={ticketAction}
				isSignUpModalActive={isActiveRegistryModal}
			/>
			<SignUpModal
				setIsVisibleConfirmationModal={setIsVisibleConfirmationModal}
				openWithoutLoginModal={handlerWithoutLoginModal}
				isActive={isActiveLoginModal}
				visible={signUpModalIsVisible}
				onClose={closeSignUpModal}
				ticketAction={ticketAction}
			/>
			<TicketWihtoutLogin
				setShowModalTemporary={setShowModalTemporary}
				ticketAction={ticketAction}
				showInputRut={showInputRutInModalWihtoutLogin}
				visible={isVisibleModalWithoutLogin}
				onClose={closeTicketWihtoutLogin}
				isDni={isDniRequired}
				isRut={isRutRequired}
				pickTicket={pickTicket}
				ticketFormsData={ticketFormsData}
				line={line}
			/>
		</>
	);
};

export default Provider(LineDetail);
